module.exports = __webpack_public_path__ + "static/share-1f3005749fc448bc3fc16562880b249a.png";